import {Meta} from '../define/utils/Meta'
import {internalErrorModel} from '../ui/internalErrorModel'

export const internalErrorMeta = new Meta(internalErrorModel.type, [], [], [], [])
